import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d1efaf34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "background customer-center-shell" }
const _hoisted_2 = { class: "mobile-center-toolbar" }
const _hoisted_3 = ["aria-expanded"]
const _hoisted_4 = { class: "menu-item" }
const _hoisted_5 = { class: "menu-level" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "个人中心首页", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_8 = { class: "menu-item" }
const _hoisted_9 = { style: {"margin-bottom":"0"} }
const _hoisted_10 = { class: "menu-level" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_14 = { class: "menu-item" }
const _hoisted_15 = { style: {"margin-bottom":"0"} }
const _hoisted_16 = { class: "menu-level" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "我的订单", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_19 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_20 = { style: {"margin-bottom":"0"} }
const _hoisted_21 = { class: "menu-level" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "我的门店", -1))
const _hoisted_23 = { class: "contents" }
const _hoisted_24 = { class: "header" }
const _hoisted_25 = { class: "content-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["cus-center", { 'mobile-profile-page': _ctx.isProfilePage }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.menuClick('/main/cuscenter/info','info')))
        }, "个人中心"),
        _createElementVNode("strong", null, _toDisplayString(_ctx.title), 1),
        _createElementVNode("button", {
          type: "button",
          "aria-expanded": _ctx.mobileMenuOpen,
          "aria-controls": "customer-center-menu",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.mobileMenuOpen=!_ctx.mobileMenuOpen))
        }, _toDisplayString(_ctx.mobileMenuOpen ? '收起入口' : '功能入口'), 9, _hoisted_3)
      ]),
      _createElementVNode("div", {
        id: "customer-center-menu",
        class: _normalizeClass(["left-menu", { 'mobile-menu-open': _ctx.mobileMenuOpen }])
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            _createVNode(_component_svg_icon, { icon: "home" }),
            _hoisted_6
          ])
        ]),
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("ul", _hoisted_9, [
            _createElementVNode("li", _hoisted_10, [
              _createVNode(_component_svg_icon, { icon: "personnel-info" }),
              _createElementVNode("span", null, _toDisplayString(_ctx.generateTitle('main.cuscenter.title')), 1)
            ]),
            _createElementVNode("li", {
              class: "menu-level2",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.menuClick('/main/cuscenter/info','info')))
            }, _toDisplayString(_ctx.generateTitle('main.cuscenter.info')), 1),
            (_ctx.securityIdentity)
              ? (_openBlock(), _createElementBlock("li", {
                  key: 0,
                  class: "menu-level2",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.menuClick('/main/cuscenter/security-notifications','securityNotifications')))
                }, [
                  _createTextVNode("系统通知"),
                  (_ctx.securityUnread>0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, "（" + _toDisplayString(_ctx.securityUnread) + " 未读）", 1))
                    : (_ctx.securityUnread===null)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, "（待刷新）"))
                      : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.clientFunctionVisible('收藏列表'))
              ? (_openBlock(), _createElementBlock("li", {
                  key: 1,
                  class: "menu-level2",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.menuClick('/main/cuscenter/favourite','favourite')))
                }, _toDisplayString(_ctx.generateTitle('main.cuscenter.favourite')), 1))
              : _createCommentVNode("", true),
            (_ctx.clientFunctionVisible('会员券管理'))
              ? (_openBlock(), _createElementBlock("li", {
                  key: 2,
                  class: "menu-level2",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.menuClick('/main/cuscenter/notes','notes')))
                }, _toDisplayString(_ctx.generateTitle('main.cuscenter.notes')), 1))
              : _createCommentVNode("", true),
            (_ctx.clientFunctionVisible('我的云盘'))
              ? (_openBlock(), _createElementBlock("li", {
                  key: 3,
                  class: "menu-level2",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.menuClick('/main/cuscenter/my-space','cloud')))
                }, _toDisplayString(_ctx.generateTitle('main.cuscenter.cloud')), 1))
              : _createCommentVNode("", true),
            (_ctx.clientFunctionVisible('意见反馈'))
              ? (_openBlock(), _createElementBlock("li", {
                  key: 4,
                  class: "menu-level2",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.menuClick('/main/cuscenter/suggestion','suggestion')))
                }, _toDisplayString(_ctx.generateTitle('main.cuscenter.suggestion')), 1))
              : _createCommentVNode("", true),
            (_ctx.clientFunctionVisible('浏览足迹'))
              ? (_openBlock(), _createElementBlock("li", {
                  key: 5,
                  class: "menu-level2",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.menuClick('/main/cuscenter/myfeet','myfeet')))
                }, _toDisplayString(_ctx.generateTitle('main.cuscenter.myfeet')), 1))
              : _createCommentVNode("", true),
            (_ctx.clientFunctionVisible('收货地址'))
              ? (_openBlock(), _createElementBlock("li", {
                  key: 6,
                  class: "menu-level2",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.menuClick('/main/cuscenter/shippingAddr','shippingAddr')))
                }, _toDisplayString(_ctx.generateTitle('main.cuscenter.shippingAddr')), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("ul", _hoisted_15, [
            _createElementVNode("li", _hoisted_16, [
              _createVNode(_component_svg_icon, { icon: "article" }),
              _hoisted_17
            ]),
            (_ctx.clientFunctionVisible('我的订单'))
              ? (_openBlock(), _createElementBlock("li", {
                  key: 0,
                  class: "menu-level2",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.menuClick('/main/cuscenter/orders','orders')))
                }, _toDisplayString(_ctx.generateTitle('main.cuscenter.orders')), 1))
              : _createCommentVNode("", true),
            (_ctx.clientFunctionVisible('我的订单'))
              ? (_openBlock(), _createElementBlock("li", {
                  key: 1,
                  class: "menu-level2",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.menuClick('/main/cuscenter/drawing-patterns','drawingPatterns')))
                }, "来图需求与订单"))
              : _createCommentVNode("", true),
            (_ctx.previliges['智能量体'])
              ? (_openBlock(), _createElementBlock("li", {
                  key: 2,
                  class: "menu-level2",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.menuClick('/main/cuscenter/scale-orders','scaleOrders')))
                }, _toDisplayString(_ctx.generateTitle('main.cuscenter.scaleOrders')), 1))
              : _createCommentVNode("", true),
            (_ctx.previliges['会员级别管理'])
              ? (_openBlock(), _createElementBlock("li", {
                  key: 3,
                  class: "menu-level2",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.menuClick('/main/cuscenter/myUpgrades','myUpgrades')))
                }, _toDisplayString(_ctx.generateTitle('main.cuscenter.myUpgrades')), 1))
              : _createCommentVNode("", true),
            (_ctx.orgId==1000)
              ? (_openBlock(), _createElementBlock("li", {
                  key: 4,
                  class: "menu-level2",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.menuClick('/main/cuscenter/courseOrders','courseOrders')))
                }, _toDisplayString(_ctx.generateTitle('main.cuscenter.courseOrders')), 1))
              : _createCommentVNode("", true),
            (_ctx.previliges['会员储值'])
              ? (_openBlock(), _createElementBlock("li", {
                  key: 5,
                  class: "menu-level2",
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.menuClick('/main/cuscenter/deposites','depositesHistories')))
                }, _toDisplayString(_ctx.generateTitle('main.cuscenter.depositesHistories')), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _hoisted_18,
        (Number(_ctx.orgId)===1000 || _ctx.clientFunctionVisible('我的门店'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("ul", _hoisted_20, [
                _createElementVNode("li", _hoisted_21, [
                  _createVNode(_component_svg_icon, { icon: "shop" }),
                  _hoisted_22
                ]),
                _createElementVNode("li", {
                  class: "menu-level2",
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.mybranchs(2))),
                  title: "已有门店直接进入管理"
                }, "开通我的微信小程序商城")
              ])
            ]))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_component_svg_icon, {
            onClick: _ctx.back,
            icon: "prev"
          }, null, 8, ["onClick"]),
          _createTextVNode(" 个人中心 / " + _toDisplayString(_ctx.title), 1)
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_router_view, null, {
            default: _withCtx(({ Component, route }) => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                key: route.path
              }))
            ]),
            _: 1
          })
        ])
      ])
    ], 2)
  ]))
}